import { useQuery } from "@tanstack/react-query";
import { getNotificationsData } from "../services/notifications.service";

export const notificationsQueryKey = ["attendance-app", "notifications"] as const;

export function useNotificationsData() {
	return useQuery({
		queryKey: notificationsQueryKey,
		queryFn: getNotificationsData,
		staleTime: 1000 * 30,
	});
}
